import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  countryCode: () => {
    return axiosInstance.get(API_URL.COUNTRY_CODE, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "allow",
        isAuthRequired: true,
      },
      params: {
        skip: 0,
        limit: 250,
      },
    });
  },

  getAllState: () => {
    return axiosInstance.get(API_URL.STATE, {
      headers: { "Content-Type": "application/json" },
    });
  },
};
